import React from 'react';
import './About.css';

const About = props => (
    <div className="About">
        <img className="About__Photo__Main" src="https://samueljoy.zenfolio.com/img/s/v-10/p4004123096-5.jpg" alt="graduation portrait of me shot by a friend"></img>
        <img className="About__Photo__Mobile" src="https://samueljoy.zenfolio.com/img/s/v-10/p3879958818-5.jpg" alt="test"></img>
        <div className="About__Text">
            <h1>hi, i'm sam!</h1>
            <p>
                I'm a web developer and fine art photographer located in Western Massachusetts.  
            </p>

            <h2>web development</h2>
            <p>
                My interest in web development started in 2018, when I took on a job with a local business in my hometown to build their new website. Since then,
                I have only developed a further interest and passion for web development, as it is the perfect blend of technical know-how and attention to detail
                with creativity and an eye for design. I have primarily worked with small businesses, photographers, and individual clients to create responsive web
                applications to suit their needs, and I am actively looking to start my career as a full-time web developer. 
            </p>
            <p>
                this web application is built with React v16.31.1, implementing the marx classless CSS framework alongside custom css styling alongside the react-photo-gallery 
                npm package for gallery formatting.
            </p>
        
            <h2>photography</h2>
            <p>
                I shoot with a wide range of cameras when it comes to photography. I develop and scan my own black & white work, with help from one of my friends
                (@thevictr on twitter) for my color film work. For digital work, my go-to setup is a canon rebel t5 with a sigma 35mmm f/1.4 art lens. For film, I switch between:
                <ul>
                    <li>nikon f2, 35mm f/2.0</li>
                    <li>lubitel 166b TLR</li>
                    <li>olympus 35rc rangefinder</li>
                    <li>nikon fg, 50mm f/1.8</li>
                </ul>

            </p>
        </div>
        
    </div>
    
);

export default About;